<!-- ./resources/assets/js/components/Home.vue -->
<template>
    <span class="label label-warning"> {{start}}</span>
</template>

<script>
    export default {
        data() {
            return {
                newPostTitle: "",
                newPostDesc: ""
            }
        },
        props: {
            start: {
                required: true,
                type: Number,
            },
        },

        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/NotificationCounter.vue